module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (236).30f6bf39.jpg";